import { SceneGenerator } from "./sceneCreator";
import { JsonUtils, Widget, SceneConfiguration } from "threngine";
import { Product } from "../sharedInterfaces";
import { ScreenshotRequest } from "threngine/dist/types/src/core/render/screenshotter";  
import { IPostSettings } from "threngine/dist/types/src/core/render/postSettings";
import * as THREE from "three";
import { Object3D, Vector3, AnimationClip, AnimationAction } from "three";
import {Group} from "three";

export class RuwacWidget {
    _widget:Widget;
    private _generator:SceneGenerator;
    private _assetFolder:string;
    private _productListUrl:string;
    private _blueprintUrl:string;
    

    constructor(blueprintPath:string, assetFolder?:string) {
        this._widget = new Widget();
        this._generator = new SceneGenerator(this._widget.services);

        this._assetFolder = assetFolder || "Assets/";
        this._productListUrl = this._assetFolder + "Scenes/product_list.json";
        this._blueprintUrl = this._assetFolder + blueprintPath;

        //FIXME: DEBUG, REMOVE
        //(<any>window).threngine = this._widget;
        //(<any>window).three = THREE;
        //(<any>window).rw = this;
    }

    private _products:Product[] = [];
    private _blueprint:SceneConfiguration;
    private _postEffects:IPostSettings;

    initialize = (div:HTMLDivElement):Promise<void> => new Promise(resolve => {
        // console.log("WIDGET INITIALIZE");
        this._widget.initialize(div, this._assetFolder)
        .then(() => JsonUtils.loadUrl(this._productListUrl))
        .then(json => {
            const list = json.products as Product[];
            this._products.push(...list);
        })
        .then(() => JsonUtils.loadUrl(this._blueprintUrl))
        .then(json => {
            this._blueprint = json.BLUEPRINT;
            this._postEffects = json.POST_EFFECTS
            this._generator.setBlueprint(this._blueprint);
        })
        .then(() => {
            //set properties of .post (post effects)
            //console.log(this._widget.services.render.post);
            const ps:IPostSettings = this._postEffects;
            const settings = this._widget.services.render.post;

            settings.ssao.enabled = ps.ssao.enabled;
            settings.ssao.aoClamp = ps.ssao.aoClamp;
            settings.ssao.lumInfluence = ps.ssao.lumInfluence;
            settings.ssao.radius = ps.ssao.radius;
            settings.ssao.near = ps.ssao.near;
            settings.ssao.far = ps.ssao.far;

            settings.bloom.enabled = ps.bloom.enabled;
            settings.bloom.strength = ps.bloom.strength;
            settings.bloom.radius = ps.bloom.radius;
            settings.bloom.threshold = ps.bloom.threshold;

            settings.render.gammaFactor = ps.render.gammaFactor;
            settings.render.gammaInput = ps.render.gammaInput;
            settings.render.gammaOutput = ps.render.gammaOutput;
            settings.render.toneMappingExposure = ps.render.toneMappingExposure;

            settings.fxaa.enabled = ps.fxaa.enabled;

            
            //DEBUG: postDebug dialog
            //this._widget.services.render.showPostDebug(true);
            resolve();
        })
        .catch((e) => {
            //FIXME: log service
            // console.log("e: ", e)
        });
    })
    
    getProducts = ():string[] => this._products.map(p => p.name);

    getBlueprint = () => this._blueprint;

    setBlueprintPath = (path:string):Promise<void> =>{
        return new Promise(resolve => {
            this._blueprintUrl = this._assetFolder + path;
            JsonUtils.loadUrl(this._blueprintUrl)
            .then(json => {
                this._blueprint = json.BLUEPRINT;
                this._generator.setBlueprint(this._blueprint);
                resolve();
            })
        })
    }

    setCamera(name:string){
        this._widget.setCamera(name, 500);
    }

    getAllMeshGroup():Promise<Group[]>{
        return this._generator.getAllGroupOfCurrentScene();
    }

    getCurrentCamera = () => {
        //FIXME: Get camera that's actually active at the moment
        const camera = this._widget.services.scene.currentSceneConfig.cameras[0];
        const pos = this._widget.services.render.controller.camera.position;

        camera.position = [pos.x, pos.y, pos.z];
        return camera;
    }

    private animations:{reverse:boolean, anim: AnimationAction}[];
    playAnimation = (name:string) => {
        if (!this.animations) return;
        
        const data = name==="Deckel" ? this.animations[0] : this.animations[1];
        data.anim.reset();
        data.anim.timeScale = data.reverse? -1:1;
        data.anim.repetitions = 1;
        data.anim.clampWhenFinished = true;
        data.anim.play();
        data.reverse = !data.reverse
    }
    
    loadProduct = (o?:{}):Promise<void> => {
        const overwriteDefault = o || {};
        //this._widget.loadGltf("Meshes/PremioGas2_XL.gltf");
        //this._widget.loadScene("Scenes/blueprint.json")
        //return Promise.resolve();
        return this._generator.loadScene(overwriteDefault).then(animation => {
            this.animations = animation.map(a => {
                return {reverse: false, anim: a}
            });

            // FIXME: Show Wireframe
            // this._widget.services.render.getAllMeshesOfCurrentScene().then(meshes =>{
            //     meshes.forEach(mesh => {
            //         (mesh.material as any).wireframe = true;
            //     })
            // })
            return Promise.resolve();
        })       
    }

    //FIXME: pass ffs parameter ()?
    takeScreenshot = (dpr:number, wh:{w?:number, h?:number}) => {
        const screenshotOptions:ScreenshotRequest = {
            dpr: dpr,
            ffs: false
        }

        if (wh.w && wh.h) {
            screenshotOptions.size = {
                width: wh.w,
                height: wh.h
            }
        }

        return this._widget.services.render.screenshot(screenshotOptions);
    }

    //maybe dead
    //generateScenes = () => this._generator.generate();




    //FIXME: Remove?
    debug_displayBoundingBox = () => {
        const scene = this._widget.services.render.scene;
        const box = new THREE.BoxHelper(scene, new THREE.Color("rgb(255, 0, 0)"));
        this._widget.services.render.scene.add(box);
    }

    private _getBoundingBoxCorners = (product:Object3D) => {
        const box = new THREE.Box3();
        const points = [
            new THREE.Vector3(),
            new THREE.Vector3(),
            new THREE.Vector3(),
            new THREE.Vector3(),
            new THREE.Vector3(),
            new THREE.Vector3(),
            new THREE.Vector3(),
            new THREE.Vector3()
        ];

        box.setFromObject(product);

        points[0].set(box.min.x, box.min.y, box.min.z); // 000
        points[1].set(box.min.x, box.min.y, box.max.z); // 001
        points[2].set(box.min.x, box.max.y, box.min.z); // 010
        points[3].set(box.min.x, box.max.y, box.max.z); // 011
        points[4].set(box.max.x, box.min.y, box.min.z); // 100
        points[5].set(box.max.x, box.min.y, box.max.z); // 101
        points[6].set(box.max.x, box.max.y, box.min.z); // 110
        points[7].set(box.max.x, box.max.y, box.max.z); // 111

        return points;
    }

    private _frustumContainsPoints = (frustum:THREE.Frustum, points:Vector3[]):boolean => {
        let allInside = true;

        points.forEach((p) => {
            if (!frustum.containsPoint(p)) {
                allInside = false;
            }
        })

        return allInside;
    }

    scaleObjectToCanvas = (scaleUp:boolean, scaleDown:boolean) => {
        return;
        const scene = this._widget.services.render.scene;

        const camera = this._widget.services.render.controller.camera;
        const frustum = new THREE.Frustum();
        const corners = this._getBoundingBoxCorners(scene);

        frustum.setFromMatrix(new THREE.Matrix4().multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse));

        //console.log("autoScale: ", frustum);

        //Scale up until bounding box barely doesn't fit inside frustum anymore
        if (scaleUp) {
            while (this._frustumContainsPoints(frustum, corners)) {
                this._widget.services.render.controller.camera.zoom *= 1.005;
                this._widget.services.render.controller.camera.updateProjectionMatrix();

                frustum.setFromMatrix(new THREE.Matrix4().multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse));

                //console.log("autoScale: scaling up");
            }
        }

        //Scale down until bounding box barely fits inside frustum
        if (scaleDown) {
            while (!this._frustumContainsPoints(frustum, corners)) {
                this._widget.services.render.controller.camera.zoom *= 0.995;
                this._widget.services.render.controller.camera.updateProjectionMatrix();

                frustum.setFromMatrix(new THREE.Matrix4().multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse));

                //console.log("autoScale: scaling down");
            }
        }

    }

    //DEBUG:
    onSceneChanged(callback:any) {
        this._widget.services.render.onSceneChanged.subscribe(callback);
    } 
}